<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/dingdan.png" class="jxyd-imgicon" />
				操作组装拆卸单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>
					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						拆卸商品
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.splitListSelected = data;}" :selectedCommodity="splitListSelected"
							:type='"2"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="splitListSelected"
							@submitSelected='data=>{this.splitListSelected = data;}' @onInputVal='onInputVal'
							:type='"2"'>
						</SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="splitListColumn" :data="documentItem.splitDetailList"></Table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						组装商品
					</div>
					<div class="layout-title-right">
						<SelectCommodityModal ref="selectCommodityModal"
							@getResult="data=>{this.assemblyListSelected = data;}"
							:selectedCommodity="assemblyListSelected" :type='"3"'></SelectCommodityModal>
						<SelectCommodityByCodeModal ref="selectCommodityByCodeModal"
							:commoditySelected="assemblyListSelected"
							@submitSelected='data=>{this.assemblyListSelected = data;}' @onInputVal='onInputVal'
							:type='"3"'>
						</SelectCommodityByCodeModal>
					</div>
				</div>
				<Table stripe :columns="assemblyListColumn" :data="documentItem.assemblyDetailList"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectCommodityModal from '@/components/SelectCommodityModal'
	import SelectCommodityByCodeModal from '@/components/SelectCommodityByCodeModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import DocumentFile from '@/components/DocumentFile'
	export default {
		name: 'purchaseplanlistfunc',
		components: {
			SelectCommodityModal,
			DocumentFile,
			SelectCommodityByCodeModal
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					splitDetailList: [],
					assemblyDetailList: [],
					userId: '',
					userName: '',
					creator: 0,
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				depotList: [],
				splitListColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.splitDetailList.splice(params
											.index,
											1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 220,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 220,
					},
					{
						title: '单位',
						key: 'unit',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.unitChange('splitDetailList', params.index, event);
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										disabled: !params.row.commodity.enableBatch,
										multiple: true,
										transfer: true,
										value: params.row.batchCode
									},
									on: {
										input: (event) => {}
									},
								},
								this.formatBatchCodeSelectData(params.index).map(function(type) {
									return h('Option', {
										props: {
											value: type.value,
											key: type.text
										}
									}, type.text);
								})
							)];
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock('splitDetailList', params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': this.getSelectedCommodityTypeMaxStock(params.index)
								},
								on: {
									input: (e) => {
										this.documentItem.splitDetailList[params.index]
											.quantity = e;
									}
								}
							})]
						}
					},
					{
						title: '零售价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentRetailPrice(params.row) + '元');
						}
					}
				],
				assemblyListColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.assemblyDetailList.splice(params
											.index,
											1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 220,
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.$router.push({
											path: 'commoditydetailinfo',
											query: {
												commodityId: params.row.commodity.id
											}
										});
									}
								}
							}, params.row.name);
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 220,
					},
					{
						title: '单位',
						key: 'unit',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (event) => {
											this.unitChange('assemblyDetailList', params.index, event);
										}
									},
								},
								params.row.commodity.extraUnits.map(function(type) {
									return h('Option', {
										props: {
											value: type.unit,
											key: type.unit
										}
									}, type.unit);
								})
							)];
						}
					},
					{
						title: '仓库',
						key: 'depotId',
						width: 130,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.depotId
									},
									style: {
										width: '100%'
									},
									on: {
										input: (event) => {
											this.documentItem.assemblyDetailList[params.index]
												.depotId = event;
										}
									},
								},
								this.depotList.map(function(depot) {
									return h('Option', {
										props: {
											value: depot.id,
											key: depot.depotName
										}
									}, depot.depotName);
								})
							)];
						}
					},
					{
						title: '保质期',
						key: 'sellbyDate',
						width: 200,
						render: (h, params) => {
							return h('DatePicker', {
								attrs: {
									transfer: true,
									type: 'daterange',
									value: params.row.sellByDate,
									placeholder: '请选择',
									disabled: !this.documentItem.assemblyDetailList[params.index].commodity
										.enableBatch
								},
								on: {
									'on-change': (e) => {
										this.documentItem.assemblyDetailList[params.index].sellByDate =
											e;
									}
								}
							})
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock('assemblyDetailList', params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.quantity,
									'max': this.getSelectedCommodityTypeMaxStock(params.index)
								},
								on: {
									input: (e) => {
										this.documentItem.splitDetailList[params.index]
											.quantity = e;
									}
								}
							})]
						}
					},
					{
						title: '零售价',
						key: 'price',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentRetailPrice(params.row) + '元');
						}
					}
				],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				}
			}
		},
		computed: {
			splitListSelected: {
				get() {
					let data = [];
					this.documentItem.splitDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {

							let dataItem = {};
							dataItem.commodity = item.commodity;

							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								unit: item.unit,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;
				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.documentItem.splitDetailList = [];
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							this.documentItem.splitDetailList.push({
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								quantity: item2.quantity,
								batchCode: this.getLatestBatchCode(item, item2),
								depotId: null,
								depotName: null,
								price: item2.retailPrice,
								discount: 100,
								priceAfterDiscount: item2.retailPrice,
								amount: formatNum(item2.quantity * item2
									.retailPrice),
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity,
								commodityId: item.commodity.id
							})
						});
					});
				}
			},
			assemblyListSelected: {
				get() {
					let data = [];
					this.documentItem.assemblyDetailList.forEach(item => {
						let formatItems = item.format.split(',');
						let priceTypeData = {};
						let imgFiles = null;
						if (formatItems.length > 1) {
							let priceTypeGroup = item.commodity.commodityPriceTypeGroups.find(m => m
								.groupName == formatItems[0]);
							if (priceTypeGroup) {
								imgFiles = priceTypeGroup.imgFiles;
							}
							priceTypeData = priceTypeGroup.commodityPriceTypes.find(m => m.priceType ==
								formatItems[1]);
						}
						let existData = data.find(m => m.commodity.id == item.commodity.id);
						let isExist = true;
						if (existData) {
							for (let i = 0; i < existData.data.length; i++) {
								if (existData.data[i].unit != item.unit) {
									isExist = false;
									break;
								}
								if (existData.data[i].priceType == item.format) {
									isExist = false;
									break;
								}
							}
						}
						if (existData && isExist) {
							existData.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: item.sellByDate,
								unit: item.unit,
								price: item.price,
								discount: item.discount,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
						} else {
							let dataItem = {};
							dataItem.commodity = item.commodity;
							dataItem.data = [];
							dataItem.data.push({
								priceType: item.format,
								quantity: item.quantity,
								imgFiles: imgFiles,
								sellByDate: item.sellByDate,
								unit: item.unit,
								price: item.price,
								discount: item.discount,
								intoPrice: priceTypeData ? priceTypeData.intoPrice : 0,
								retailPrice: priceTypeData ? priceTypeData.retailPrice : 0,
								wholesalePricePrice: priceTypeData ? priceTypeData
									.wholesalePricePrice : 0
							});
							data.push(dataItem);
						}
					});
					return data;
				},
				set(newValue) {
					//这的data就是B页面传递过来的数据
					this.documentItem.assemblyDetailList = []
					newValue.forEach(item => {
						item.data.forEach(item2 => {
							let detail = {
								commodityId: item.commodity.id,
								name: item.commodity.name,
								unit: item2.unit,
								format: item2.priceType,
								quantity: item2.quantity,
								depotId: null,
								depotName: null,
								price: 0,
								sellByDate: item2.sellByDate,
								discount: item2.discount ? item2.discount : 100,
								priceAfterDiscount: 0,
								amount: 0,
								note: '',
								creator: parseInt(localStorage.getItem("userId")),
								commodity: item.commodity,
								commodityId: item.commodity.id
							};
							detail.price = item2.price ? item2.price : this.getCommodityTypePrice(
								detail);
							detail.priceAfterDiscount = formatNum(detail.price * (detail.discount /
								100));
							detail.amount = formatNum(detail.quantity * detail
								.priceAfterDiscount)
							this.documentItem.assemblyDetailList.push(detail);
						});
					});
				}
			},
		},
		methods: {
			formatBatchCodeSelectData(index) {
				let data = this.documentItem.splitDetailList[index];
				if (data) {
					let list = []
					let unitData = this.getUnitData(data, data.unit);
					if (data.commodity.commodityInventorys && unitData) {
						let array = data.commodity.commodityInventorys.filter(m => m.stock > 0 && m
							.commodityPriceType == data.format);
						array = array.sort((a, b) => new Date(a.sellByDate[1]) - new Date(b.sellByDate[1]));
						for (let i = 0; i < array.length; i++) {
							list.push({
								value: array[i].batchCode,
								text: `${array[i].batchCode}(${formatNum(array[i].stock * unitData.conversionRate)}${data.unit})`
							})
						}
					}
					return list;
				}
				return [];
			},
			getCurrentRetailPrice(data) {
				let items = data.format.split(',');
				if (items.length <= 0) {
					return 0;
				}
				let priceTypeGroup = data.commodity
					.commodityPriceTypeGroups.find(m => m.groupName == items[0]);
				if (!priceTypeGroup || priceTypeGroup.commodityPriceTypes.length <= 0) {
					return 0;
				}
				let priceType = priceTypeGroup.commodityPriceTypes.find(m => m.priceType == items[1]);
				if (!priceType) {
					return 0;
				}
				let unitData = this.getUnitData(data, data.unit);
				if (!unitData) {
					return 0;
				}
				return formatNum(priceType.retailPrice / unitData.conversionRate);
			},
			getSelectedCommodityTypeMaxStock(index) {
				let detail = this.documentItem.splitDetailList[index];
				if (!detail.commodity.commodityInventorys) return 0;
				let stock = 0;
				let commodityInventorys = detail.commodity.commodityInventorys;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == detail.format) {
						stock += commodityInventorys[i].stock;
					}
				}

				// 减去已选数量
				let details = this.documentItem.splitDetailList;
				for (let i = 0; i < details.length; i++) {
					if (i != index) {
						if (detail.format == details[i].format) {
							for (let j = 0; j < details[i].commodity.extraUnits.length; j++) {
								if (details[i].unit == details[i].commodity
									.extraUnits[j].unit) {
									stock -= details[i].quantity / details[i]
										.commodity.extraUnits[j].conversionRate;
								}
							}
						}
					}
				}

				let unitData = detail.commodity.extraUnits.find(m => m.unit == detail.unit);

				if (unitData) {
					stock = unitData.conversionRate * stock;
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getUnitData(item, unit) {
				if (item.commodity.extraUnits) {
					let unitData = item.commodity.extraUnits.find(m => m.unit == unit);
					if (unitData) {
						return unitData;
					}
				}
				return null;
			},
			getLatestBatchCode(item1, item2) {
				if (item1.commodity.enableBatch != true) {
					return null;
				}
				if (!item1.commodity.commodityInventorys || item1.commodity.commodityInventorys.length <= 0) {
					return null;
				}
				let codes = [];
				let totalStock = 0;
				let unitData = this.getUnitData(item1, item2.unit);
				if (unitData) {
					let latestCode = item1.commodity.commodityInventorys.filter(m => m.stock > 0 && m
						.commodityPriceType == item2.priceType).sort((a, b) => new Date(a.sellByDate[1]) - new Date(b
						.sellByDate[1]));
					for (let i = 0; i < latestCode.length; i++) {
						totalStock += formatNum(latestCode[i].stock * unitData.conversionRate);
						codes.push(latestCode[i].batchCode);
						if (totalStock > item2.quantity) {
							break;
						}
					}
				}
				return codes;
			},
			unitChange(tag, index, val) {
				this.documentItem[tag][index].unit = val;
				for (let i = 0; i < this.documentItem[tag][index].commodity.extraUnits
					.length; i++) {
					if (this.documentItem[tag][index].commodity.extraUnits[i].unit == val) {
						let price = this.getCommodityTypePrice(this.documentItem[tag][index]
							.commodity, this.documentItem[tag][index].format);
						this.documentItem[tag][index].price = formatNum(
							price / this
							.documentItem[tag][index].commodity.extraUnits[i]
							.conversionRate);
						this.documentItem[tag][index].stock = formatNum(this.documentItem[tag][index].commodity
							.stock * this.documentItem[tag][
								index
							].commodity.extraUnits[i].conversionRate)
					}
				}
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.commodity.extraUnits.find(m => m.unit == data.unit);
				// 解析价格类型
				const priceTypeItems = data.format.split(',');
				let currentPriceType = null;

				if (priceTypeItems.length === 2) {
					currentPriceType = this.findPriceType(data.commodity, priceTypeItems);
				}
				if (currentUnit && currentPriceType) {
					let price = currentPriceType.intoPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			// 提取价格类型查找逻辑
			findPriceType(commodity, priceTypeItems) {
				const [groupName, priceTypeName] = priceTypeItems;

				const targetGroup = commodity.commodityPriceTypeGroups.find(
					group => group.groupName === groupName
				);

				if (!targetGroup) return null;

				return targetGroup.commodityPriceTypes.find(
					priceType => priceType.priceType === priceTypeName
				) || null;
			},
			emptyForm() {
				this.documentItem.id = 0
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.splitDetailList = [];
				this.documentItem.assemblyDetailList = [];
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.checkState = 1; //未审核
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (this.documentItem.splitDetailList.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择拆卸商品"
					});
					return false
				}

				if (this.documentItem.assemblyDetailList.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择组装商品"
					});
					return false
				}

				let details = this.documentItem.splitDetailList;
				for (let i = 0; i < details.length; i++) {
					if (details[i].commodity.enableBatch == true && (!details[i].batchCode || details[i].batchCode
							.length <= 0)) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '拆卸商品中' + details[i].format + "规格未选择批次号"
						});
						return false
					}
				}

				let assemblyDetails = this.documentItem.assemblyDetailList;
				for (let i = 0; i < assemblyDetails.length; i++) {
					if (!assemblyDetails[i].depotId) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '拆卸商品中' + assemblyDetails[i].format + "规格未选择入库仓库"
						});
						return false
					}
					if (assemblyDetails[i].commodity.enableBatch == true && assemblyDetails[i].sellByDate.length < 2) {
						this.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '组装商品中' + assemblyDetails[i].format + "规格未设置保质期"
						});
						return false
					}
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/SplitList/EditSplitList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录组装拆卸单操作
					var log = {
						FlowId: response.data,
						Title: '组装拆卸单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此组装拆卸单' : '创建了此组装拆卸单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}

					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});


				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/SplitList/EditSplitList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录组装拆卸单操作
					var log = {
						FlowId: response.data,
						Title: '组装拆卸单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此组装拆卸单' : '创建了此组装拆卸单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					self.documentItem.id = response.data;
					self.checkSplitList(self.documentItem.id, '组装拆卸单过账后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/SplitList/GetNextCode', {
					params: {
						prefix: 'ZCD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/SplitList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "组装拆卸单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '组装拆卸单日志',
									OperationContent: '回滚了此组装拆卸单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getSplitList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkSplitList(id, func) {
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/SplitList/CheckSplitList', [{
							id: id,
							state: 2
						}]).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							//记录采购单操作
							log.push({
								FlowId: id,
								Title: '组装拆卸单日志',
								OperationContent: '审核了此组装拆卸单',
								Operator: parseInt(localStorage.getItem("userId")),
								State: 1,
								Creator: parseInt(localStorage.getItem("userId"))
							});

							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '审核成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['SplitList.Add', 'SplitList.Edit', 'SplitList.Delete',
						'SplitList.Audit', 'SplitList.BatchAudit', 'SplitList.Print',
						'SplitList.Rollback', 'SplitList.Export', 'SplitList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'SplitList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'SplitList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'SplitList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'SplitList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'SplitList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'SplitList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'SplitList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'SplitList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'SplitList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getSplitList(splitListId) {
				let self = this;
				request.get('/api/SplitList/GetSplitList', {
					params: {
						id: splitListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initSplitList(response.data);
				}).catch(function(error) {})
			},
			initSplitList(data) {
				this.documentItem = data;
			},
			packPrintData(data) {
				data.forEach((item, index) => {
					switch (item.checkState) {
						case 1:
							item.checkState = '已创建'
							break;
						case 2:
							item.checkState = '已审核'
							break;
						case 3:
							item.checkState = '已完结'
							break;
					}
					item.businessDate = item.businessDate.replace(' 00:00:00', '');
					for (let i = 0; i < item.splitDetailList.length; i++) {
						item.splitDetailList[i].stock = self.getCurrentIStock('splitDetailList',i);
						item.splitDetailList[i].price = self.getCurrentRetailPrice(item.splitDetailList[i]);
					}
					for (let i = 0; i < item.assemblyDetailList.length; i++) {
						item.assemblyDetailList[i].stock = self.getCurrentIStock('assemblyDetailList',i);
						item.assemblyDetailList[i].price = self.getCurrentRetailPrice(item.assemblyDetailList[i]);
					}
				})
				let selectedReceiptData = {
					name: 'splitList',
					title: '组装拆卸单',
					attributes: ['baseFieldItem', 'splitDetailList', 'assemblyDetailList'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						},
						{
							name: 'createDate',
							displayName: '创建时间'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					],
					assemblyDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						{
							name: 'price',
							displayName: '零售价'
						},
						{
							name: 'stock',
							displayName: '商品库存'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						}
					],
					splitDetailList: [{
							name: 'name',
							displayName: '商品名'
						},
						{
							name: 'format',
							displayName: '商品规格'
						},
						{
							name: 'price',
							displayName: '零售价'
						},
						{
							name: 'stock',
							displayName: '商品库存'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						}
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
			onInputVal(val) {
				this.$refs.selectCommodityModal.searchItems.name = val;
				this.$refs.selectCommodityModal.openSelectCommodityModal();
			},
			getCurrentIStock(tag, index) {
				let commodityInventorys = this.documentItem[tag][index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem[tag][index].format) {
						stock += commodityInventorys[i].stock;
					}
				}

				let extraUnits = this.getUnitData(this.documentItem[tag][index], this.documentItem[tag][index].unit);
				if (extraUnits) {
					stock = extraUnits.conversionRate * stock;
				}
				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			}
		},
		watch: {
			'documentItem.splitDetailList': {
				deep: true,
				handler(arr) {}
			},
			'$route.query.splitListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getSplitList(param);
					} else {
						this.emptyForm();
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initDepotData();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>